import { createRequestTypes } from "../../../utils/createActionTypes";

export const GET_TRADE = createRequestTypes("GET_TRADE")
export const GET_TRADES = createRequestTypes("GET_TRADES")
export const CREATE_TRADE = createRequestTypes("CREATE_TRADE")
export const UPDATE_TRADE = createRequestTypes("UPDATE_TRADE")
export const DELETE_TRADE = createRequestTypes("DELETE_TRADE")
export const SEARCH_TRADE = createRequestTypes("SEARCH_TRADE")
